import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const globcomeldConfig: TSPConfig = {
  key: 'globcomeld',
  name: 'Globcom ELD',
  imageName: 'GlobcomELD',
  category: TSPCategory.CUSTOM,
  helpText: 'Please input the Company ID from your Globcom ELD profile.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Enter Company ID',
          name: 'authorizationcode',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default globcomeldConfig;
